import Navbar from '../components/Navbar';
import Banner from '../components/Banner';
import Services from '../components/Services';
import WorkingProcess from '../components/WorkingProcess';
import ContactForm from '../components/ContactForm';

function Home() {
  return (
    <div>
      <Navbar />
      <div id="banner">
        <Banner />
      </div>
      <div id="services">
        <Services />
      </div>
      <div id="working-process">
        <WorkingProcess />
      </div>
      <div id="contact-form">
        <ContactForm />
      </div>
    </div>
  );
}

export default Home;
